import Messages from '../constants/messages'
import { required, lookUpRequired } from '../utils/validationRules'

export const groupTableOptions = [
  {
    name: 'name',
    friendlyName: Messages['uiComponents']['TABLE_NAME_COLUMN'],
    displayType: 'link'
  },
  {
    name: 'description',
    friendlyName: Messages['uiComponents']['TABLE_DESCRIPTION_COLUMN'],
    displayType: 'string'
  },
  {
    name: 'users',
    friendlyName: Messages['uiComponents']['TABLE_USERS_COLUMN'],
    displayType: 'count'
  },
  {
    name: 'partner',
    friendlyName: Messages['uiComponents']['TABLE_PARTNER_NAME_COLUMN'],
    displayType: 'stringNested'
  }
]

export const userTableOptions = [
 {
   name: 'fullName',
   friendlyName: Messages['uiComponents']['TABLE_NAME_COLUMN'],
   displayType: 'link',
 },
 {
   name: 'email',
   friendlyName: Messages['uiComponents']['TABLE_EMAIL_COLUMN'],
   displayType: 'string'
 },
 {
   name: 'partners',
   friendlyName: Messages['uiComponents']['TABLE_PARTNER_NAME_COLUMN'],
   displayType: 'commaSeparated'
 },
 {
   name: 'partners',
   friendlyName: Messages['uiComponents']['TABLE_PARTNER_ID_COLUMN'],
   displayType: 'commaSeparatedId'
 },
 {
   name: 'status',
   friendlyName: Messages['uiComponents']['TABLE_STATUS_COLUMN'],
   displayType: 'verified'
 }
]

export const usersTableOptions = [
 {
   name: 'name',
   friendlyName: Messages['uiComponents']['TABLE_NAME_COLUMN'],
   displayType: 'string',
 },
 {
   name: 'username',
   friendlyName: Messages['uiComponents']['TABLE_USER_NAME_COLUMN'],
   displayType: 'string'
 }
]

export const roleTableOptions = [
  {
    name: 'name',
    friendlyName: Messages['uiComponents']['TABLE_NAME_COLUMN'],
    displayType: 'string',
  },
  {
    name: 'applicationId',
    friendlyName: Messages['uiComponents']['TABLE_APPLICATION_ID_COLUMN'],
    displayType: 'string'
  },
  {
    name: 'description',
    friendlyName: Messages['uiComponents']['TABLE_DESCRIPTION_COLUMN'],
    displayType: 'string'
  }
]

export const tempMockClientList = [
  {
    applicationName: "Test App 1",
    applicationId: "123rqf3g4vsd",
    applicationType: "SPA"
  },
  {
    applicationName: "Test App 2",
    applicationId: "dlsakngvlgsand",
    applicationType: "SPA"
  },
  {
    applicationName: "Test App 3",
    applicationId: "vndjk3o2ifnsd",
    applicationType: "SPA"
  }
]

export const adminNewGroupOptions = [
  {
    type: 'partnerManualLookup',
    name: 'partnerId',
    friendlyName: Messages['uiComponents']['PARTNER_ID_INPUT_FIELD'],
    validationRules: [lookUpRequired]
  },
  {
    type: 'roleDropdown',
    name: 'roleIds',
    friendlyName: Messages['uiComponents']['GROUP_ROLE_SELECT_FIELD'],
    validationRules: [required]
  },
  {
    type: 'textField',
    name:'name',
    friendlyName: Messages['uiComponents']['GROUP_NAME_INPUT_FIELD'],
    validationRules: [required]
  },
  {
    type: 'textField',
    name:'description',
    friendlyName: Messages['uiComponents']['GROUP_DESCRIPTION_INPUT_FIELD'],
    validationRules: [required]
  }
]

export const partnerNewGroupOptions = [
  {
    type: 'partnerDropdown',
    name: 'partner',
    multiple: false,
    friendlyName: Messages['uiComponents']['GROUP_PARTNER_SELECT_FIELD'],
    validationRules: [required]
  },
  {
    type: 'roleDropdown',
    name: 'roleIds',
    friendlyName: Messages['uiComponents']['GROUP_ROLE_SELECT_FIELD'],
    validationRules: [required]
  },
  {
    type: 'textField',
    name:'name',
    friendlyName: Messages['uiComponents']['GROUP_NAME_INPUT_FIELD'],
    validationRules: [required]
  },
  {
    type: 'textField',
    name:'description',
    friendlyName: Messages['uiComponents']['GROUP_DESCRIPTION_INPUT_FIELD'],
    validationRules: [required]
  }
]
